import Cost from "../../../../pages/Config/CostGlobal";
import CostNewEdit from "../../../../pages/Config/CostGlobal/NewEdit";

const routerCost = [
    {
        key: "costs",
        path: "/config/costs",
        element: <Cost />,
    },
    {
        key: "costs",
        path: "/config/costs/new",
        element: <CostNewEdit />,
    },
    {
        key: "costs",
        path: "/config/costs/:id",
        element: <CostNewEdit />,
    },
]

export default routerCost
